import { EpimsBankDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadEpimsBank = createAction('[EpimsBank] Load EpimsBank');

export const loadEpimsBankSuccess = createAction(
  '[EpimsBank] Load EpimsBank Success',
  props<{ bank: EpimsBankDto[] }>()
);

export const loadEpimsBankFailure = createAction(
  '[EpimsBank] Load EpimsBank Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addEpimsBank = createAction(
  '[EpimsBank] Add EpimsBank',
  props<{ newEpimsBank: EpimsBankDto[] }>()
);

export const addEpimsBankSuccess = createAction(
  '[EpimsBank] Add EpimsBank Success',
  props<{ newEpimsBank: EpimsBankDto[] }>()
);

export const addEpimsBankFailure = createAction(
  '[EpimsBank] Add EpimsBank Failure',
  props<{ error: any }>()
);

/**
 * Update EpimsBank Collection Actions
 */
export const updateEpimsBank = createAction(
  '[EpimsBank] Update EpimsBank',
  props<{ updateEpimsBank: EpimsBankDto[] }>()
);

export const updateEpimsBankSuccess = createAction(
  '[EpimsBank] Update EpimsBank Success',
  props<{ updateEpimsBank: EpimsBankDto[] }>()
);

export const updateEpimsBankFailure = createAction(
  '[EpimsBank] Update EpimsBank Failure',
  props<{ error: any }>()
);

/**
 * Remove EpimsBank Collection Actions
 */
export const removeEpimsBank = createAction(
  '[EpimsBank] Remove EpimsBank',
  props<{ ids: string[] }>()
);

export const removeEpimsBankSuccess = createAction(
  '[EpimsBank] Remove EpimsBank Success',
  props<{ ids: string[] }>()
);

export const removeEpimsBankFailure = createAction(
  '[EpimsBank] Remove EpimsBank Failure',
  props<{ error: any }>()
);
